export default __webpack_public_path__ + "static/media/section2_Img1.063ca0c7.png";